<template>
    <div>
        <rkm-list
            :items="data.model.atestados"
            hide-filters
            hide-pagination
            item-cursor="default"
        >
            <template v-slot="{item}">
                <template v-if="item.modeloId === enums.atestadoModelo.PADRAO">
                    <rkm-row>
                        <rkm-col cols="8">
                            <strong>Nome</strong><br />{{item.nome}}
                        </rkm-col>

                        <rkm-col cols="4">
                            <strong>Acmpanhante</strong><br />{{item.isAtestadoAcompanhante ? 'Sim' : 'Não'}}
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col
                            v-if="item.documentoTipoId === enums.documentoTipo.CPF"
                            cols="2"
                        >
                            <strong>CPF</strong><br />{{item.cpf}}
                        </rkm-col>

                        <rkm-col
                            v-else-if="item.documentoTipoId === enums.documentoTipo.CNS"
                            cols="2"
                        >
                            <strong>CNS</strong><br />{{item.cns}}
                        </rkm-col>

                        <rkm-col cols="2">
                            <strong>Data</strong><br />{{item.data}}
                        </rkm-col>

                        <rkm-col cols="2">
                            <strong>Hora</strong><br />{{item.horario}}
                        </rkm-col>

                        <rkm-col cols="2">
                            <strong>Dias</strong><br />{{item.dias}}
                        </rkm-col>

                        <rkm-col>
                            <strong>CID 10</strong><br />{{item.cid ? `${item.cid.codigo} - ${item.cid.nome}` : ''}}
                        </rkm-col>
                    </rkm-row>
                </template>

                <rkm-row v-else>
                    <rkm-col cols="12">
                        <strong>Descrição</strong><br /> {{item.descricao}}
                    </rkm-col>
                </rkm-row>
            </template>

            <template v-slot:trailling="{index, item}">
                <rkm-button
                    @click="$refs.Modal.open(item)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click="destroy(index)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-list>

        <rkm-area
            background-color="primary"
            closed
            title="Histórico de atestados"
            type="box"
        >
            <rkm-list
                :items="data.form.atestados"
                hide-filters
                hide-pagination
                item-cursor="default"
            >
                <template v-slot="{item}">
                    <rkm-row>
                        <rkm-col>
                            <strong>Data / Hora</strong><br />{{item.dataHora}}
                        </rkm-col>

                        <rkm-col>
                            <strong>Setor</strong><br />{{item.centroCusto.setor.nome}}
                        </rkm-col>

                        <rkm-col>
                            <strong>Profissional</strong><br />{{item.lotacao.profissional.nome}} - {{item.lotacao.ocupacao.nome}}
                        </rkm-col>
                    </rkm-row>

                    <hr />

                    <template v-if="item.modeloId === enums.atestadoModelo.PADRAO">
                        <rkm-row>
                            <rkm-col cols="8">
                                <strong>Nome</strong><br />{{item.nome}}
                            </rkm-col>

                            <rkm-col cols="4">
                                <strong>Acmpanhante</strong><br />{{item.isAtestadoAcompanhante ? 'Sim' : 'Não'}}
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col
                                v-if="item.documentoTipoId === enums.documentoTipo.CPF"
                                cols="2"
                            >
                                <strong>CPF</strong><br />{{item.cpf}}
                            </rkm-col>

                            <rkm-col
                                v-else-if="item.documentoTipoId === enums.documentoTipo.CNS"
                                cols="2"
                            >
                                <strong>CNS</strong><br />{{item.cns}}
                            </rkm-col>

                            <rkm-col cols="2">
                                <strong>Data</strong><br />{{item.data}}
                            </rkm-col>

                            <rkm-col cols="2">
                                <strong>Hora</strong><br />{{item.horario}}
                            </rkm-col>

                            <rkm-col cols="2">
                                <strong>Dias</strong><br />{{item.dias}}
                            </rkm-col>

                            <rkm-col>
                                <strong>CID 10</strong><br />{{item.cid ? `${item.cid.codigo} - ${item.cid.nome}` : ''}}
                            </rkm-col>
                        </rkm-row>
                    </template>

                    <rkm-row v-else>
                        <rkm-col cols="12">
                            <strong>Descrição</strong><br /> {{item.descricao}}
                        </rkm-col>
                    </rkm-row>
                </template>
            </rkm-list>
        </rkm-area>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'

// Enums.
import atestadoModelo from '@/enums/ambulatorio/atestadoModelo'
import documentoTipo from '@/enums/cadastro/documentoTipo'

export default {
    components: {Modal},
    data: () => ({
        enums: {
            atestadoModelo,
            documentoTipo,
        },
    }),
    methods: {
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o atestado?', async () => {
                this.data.model.atestados.splice(index, 1)
            })
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>